<template>
  <div></div>
</template>

<script>
import axios from "axios";
import baseUrl from "../../../util/backend";
import fileUrl from "../../../util/backendfile";
import moment from "moment";
import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/sarabun-font.js";

export default {
  emits: ["add-file"],
  props: ["type"],
  data() {
    return {
      accounting: null,
      detail: null,
      bankpayment: null,
      createDate: moment(new Date()).format("DD MMM YYYY"),
      receiptID: "",
      noteTax: null,
      price: null,
      tax: null,
      net: null,
      payMethod: "",
      amount: null,
      chequeBank: null,
      chequeNo: null,
      chequeDate: null,
      authorize: null,
      difference: null,
      diffValue: null,
      folderId: null,
      tableBody: [],
      receiptFile: null,
    };
  },
  computed: {
    formattedAccountingAddress() {
      return this.accounting.province === "กรุงเทพมหานคร"
        ? " เขต" +
            this.accounting.subdistrict +
            " แขวง" +
            this.accounting.district +
            " " +
            this.accounting.province +
            " " +
            this.accounting.postcode
        : " ต." +
            this.accounting.subdistrict +
            " อ." +
            this.accounting.district +
            " จ." +
            this.accounting.province +
            " " +
            this.accounting.postcode;
    },
    formattedCompanyAddress() {
      return this.detail.province === "กรุงเทพมหานคร"
        ? "เขต" +
            this.detail.subdistrict +
            " แขวง" +
            this.detail.district +
            " " +
            this.detail.province +
            " " +
            this.detail.postcode
        : "ต." +
            this.detail.subdistrict +
            " อ." +
            this.detail.district +
            " จ." +
            this.detail.province +
            " " +
            this.detail.postcode;
    },
  },
  methods: {
    numberComma(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    taskDateFormat(name, date) {
      if (
        [
          "ค่าสอบบัญชี",
          "ค่าบริการงานบัญชีและปิดงบการเงินประจำปี",
          "ค่าบริการงานบัญชีประจำปี",
          "ค่าบริการจัดหาผู้สอบบัญชี",
        ].includes(name)
      ) {
        return `ปี ${moment(date).format("YYYY")}`;
      }
      if (
        [
          "ค่าบริการงานทะเบียน",
          "ค่าบริการจดทะเบียนบริษัท",
          "ค่าบริการคัดหนังสือรับรองและสำเนาเอกสาร",
          "ค่า Messenger",
        ].includes(name)
      ) {
        return "";
      }
      return `เดือน ${moment(date).format("MM/YYYY")}`;
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = url;
      });
    },
    getFile() {
      return this.receiptFile;
    },
    async getData(id) {
      const res = await axios.get(`${baseUrl}/receipt/get?receipt_id=${id}`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      console.log(res);
      this.folderId = res.data.folder_id;
      const receiptData = res.data.data;
      this.receiptID = receiptData.receipt_code;
      this.accounting = receiptData.accounting;
      this.detail = receiptData.detail;
      this.bankpayment = receiptData.bankpayment;
      this.createDate = moment(receiptData.date).format("DD MMM YYYY");
      this.payMethod = receiptData.payment_method;
      this.amount = receiptData.amount;
      this.price = receiptData.price;
      this.tax = receiptData.tax;
      this.net = receiptData.net;
      this.noteTax = receiptData.note_tax;
      this.chequeBank = receiptData.cheque_bank;
      this.chequeNo = receiptData.cheque_number;
      this.chequeDate = moment(receiptData.cheque_date).format("DD/MM/YYYY");
      this.authorize = receiptData.authorize;
      this.difference = receiptData.difference;
      this.diffValue = receiptData.difference_value;
      // NOTE create table body
      for (const invoice of receiptData.invoice) {
        this.tableBody.push(
          {
            text: [
              `ใบแจ้งหนี้ เลขที่ `, 
              {text: `${invoice.invoice_code}`, color: "#6E7DDA"},
            ],
            style: "invoiceNumber",
          }
        );
        let invoiceBody = [];
        invoiceBody.push([
          {
            text: "No.",
            style: ["itemsHeader", "center"],
            fillColor: "#ebebeb",
          },
          {
            text: "Description",
            style: ["itemsHeader", "center"],
            fillColor: "#ebebeb",
          },
          {
            text: "Withholding Tax",
            style: ["itemsHeader", "center"],
            fillColor: "#ebebeb",
          },
          {
            text: "Amount (Bath)",
            style: ["itemsHeader", "center"],
            fillColor: "#ebebeb",
          },
        ]);
        let taskIndex = 1;
        for (const task of invoice.task) {
          invoiceBody.push([
            {
              text: taskIndex,
              style: ["itemNumber", "center"],
            },
            {
              text: `${task.task.task_name} ${this.taskDateFormat(
                task.task.task_name,
                task.task.date
              )}`,
              style: "itemName",
            },
            {
              text: task.task.tax ? task.task.tax + " %" : "-",
              style: "itemTax",
            },
            {
              text: this.numberComma(task.task.price.toFixed(2)),
              style: "itemTotal",
            },
          ]);
          taskIndex = taskIndex + 1;
        }
        this.tableBody.push({
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: [40, 270, 90, 90],
            body: invoiceBody,
          }, // table
          //  layout: 'lightHorizontalLines'
          layout: {
            hLineColor: function(i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "black"
                : "white";
            },
          },
        });
      }
    },
    async generateReport(id) {
      await this.getData(id);
      pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
      pdfMake.fonts = {
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
        },
        // Kanit Font
        Kanit: {
          // 3. set Kanit font
          normal: "Kanit-Regular.ttf",
          bold: "Kanit-Medium.ttf",
          italics: "Kanit-Italic.ttf",
          bolditalics: "Kanit-MediumItalic.ttf",
        },
        THSarabun: {
          normal: "THSarabun.ttf",
          bold: "THSarabunBold.ttf",
          italics: "THSarabunItalic.ttf",
          bolditalic: "THSarabunBoldItalic.ttf",
        },
      };
      var docDefinition = {
        // header: {
        //   columns: [
        //     { text: "HEADER LEFT", style: "documentHeaderLeft" },
        //     { text: "HEADER CENTER", style: "documentHeaderCenter" },
        //     { text: "HEADER RIGHT", style: "documentHeaderRight" },
        //   ],
        // },
        // footer: {
        //   columns: [
        //     { text: "FOOTER LEFT", style: "documentFooterLeft" },
        //     { text: "FOOTER CENTER", style: "documentFooterCenter" },
        //     { text: "FOOTER RIGHT", style: "documentFooterRight" },
        //   ],
        // },
        content: [
          // Header
          {
            columns: [
              [
                {
                  text: this.accounting.name_th,
                  style: "invoiceTitle",
                  width: "*",
                },
                {
                  text: this.accounting.address,
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text: this.formattedAccountingAddress,
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text: "อีเมล: " + this.accounting.email,
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text: `Tax ID: ${this.accounting.tax_id}`,
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text:
                    "เบอร์โทร: " +
                    this.accounting.phone +
                    " อีเมล: " +
                    this.accounting.email,
                  style: "invoiceSubTitle",
                  width: "*",
                },
              ],
              [
                this.accounting.logo
                  ? {
                      image: await this.getBase64ImageFromURL(
                        this.accounting.logo
                      ),
                      width: 70,
                      alignment: "right",
                      margin: [0, 0, 0, 10],
                    }
                  : null,
              ],
            ],
          },
          {
            canvas: [
              {
                type: "line",
                lineColor: "#47c360",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 5,
              },
            ],
          },
          [
            {
              text: "ใบเสร็จรับเงิน  / RECEIPT",
              style: "invoiceText",
            },
            {
              text: `(${this.type})`,
              style: "invoiceStatus",
            },
          ],
          // Billing Headers
          {
            columns: [
              {
                text: "ข้อมูลลูกค้า",
                style: "memberTitle",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: "Receipt No : ",
                        style: "invoiceDetail",
                        width: "*",
                      },
                      {
                        text: this.receiptID,
                        style: "invoiceDetail",
                        color: "#00A86C",
                        width: 100,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            columns: [
              {
                text: `${this.detail.company_name} ${
                  this.detail.headquarter
                    ? "(สำนักงานใหญ่)"
                    : `(${this.detail.branch_name})`
                }`,
                style: "memberDetail",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: "Date : ",
                        style: "invoiceDetail",
                        width: "*",
                      },
                      {
                        text: this.createDate,
                        style: "invoiceDetail",
                        width: 100,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            columns: [
              [
                {
                  text: this.detail.address,
                  style: "memberDetail",
                  width: 200,
                },
                {
                  text: this.formattedCompanyAddress,
                  style: "memberDetail",
                  width: 200,
                },
              ],
            ],
          },
          {
            columns: [
              {
                text: `Tax ID : ${this.detail.tax_id}`,
                style: "memberDetail",
              },
            ],
          },
          // {
          //   canvas: [
          //     {
          //       type: "line",
          //       lineColor: "#7e7e7e",
          //       x1: 0,
          //       y1: 0,
          //       x2: 250,
          //       y2: 0,
          //       lineWidth: 1,
          //       margin: [0, 5, 0, 0],
          //     },
          //   ],
          // },
          // {
          //   text: `ชื่อผู้ติดต่อ : ${this.detail.contact_name}`,
          //   style: "contact",
          // },
          {
            text: `เบอร์โทร : ${this.detail.contact_phone} อีเมล : ${this.detail.contact_email}`,
            style: "memberDetail",
          },
          // {
          //   text: `เบอร์โทร : ${this.detail.contact_phone}`,
          //   style: "memberDetail",
          // },
          // Line breaks
          "\n",
          // Items
          this.tableBody,
          // Line breaks
          "\n",
          // Items
          {
            columns: [
              {
                columns: [
                  {
                    stack: [
                      {
                        text: this.noteTax
                          ? `หมายเหตุ : ภาษีมูลค่าเพิ่มชำระเกินสะสม ${this.noteTax} บาท รอนำไปหักภาษีขายเดือนถัดไป`
                          : "",
                        style: "memberDetail",
                      },
                      {
                        columns: [
                          {
                            text: "วิธีการชำระเงิน :",
                            style: "memberDetail",
                          },
                          {
                            text: this.payMethod,
                            style: "memberDetail",
                          },
                          {
                            text: "",
                          },
                          {
                            text: "",
                          },
                        ],
                      },
                      {
                        columns: [
                          {
                            text: "ธนาคาร :",
                            style: "memberDetail",
                          },
                          {
                            text:
                              this.payMethod === "โอนเงิน"
                                ? this.bankpayment.bank
                                : this.chequeBank,
                            style: "memberDetail",
                          },
                          {
                            text: "",
                          },
                          {
                            text: "",
                          },
                        ],
                      },
                      {
                        columns: [
                          {
                            text: "เลขที่ :",
                            style: "memberDetail",
                          },
                          {
                            text:
                              this.payMethod === "โอนเงิน"
                                ? this.bankpayment.acc_number
                                : this.chequeNo,
                            style: "memberDetail",
                          },
                          {
                            text: "",
                          },
                          {
                            text: "",
                          },
                        ],
                      },
                      {
                        columns: [
                          {
                            text: "วันที่ :",
                            style: "memberDetail",
                          },
                          {
                            text:
                              this.payMethod === "โอนเงิน"
                                ? this.createDate
                                : this.chequeDate,
                            style: "memberDetail",
                          },
                          {
                            text: "",
                          },
                          {
                            text: "",
                          },
                        ],
                      },
                      {
                        columns: [
                          {
                            text: "จำนวนเงิน(บาท) :",
                            style: "memberDetail",
                          },
                          {
                            text: this.numberComma(this.amount.toFixed(2)),
                            style: "memberDetail",
                          },
                          {
                            text: "",
                          },
                          {
                            text: "",
                          },
                        ],
                      },
                    ],
                    unbreakable: true,
                  },
                ],
                width: 330,
              },
              {
                stack: [
                  {
                    table: {
                      // headers are automatically repeated if the table spans over multiple pages
                      // you can declare how many rows should be treated as headers
                      dontBreakRows: true,
                      widths: [90, 90],
                      body: [
                        // Table Header
                        [
                          {
                            text: "Total",
                            style: "itemName",
                          },
                          {
                            text: this.numberComma(this.price.toFixed(2)),
                            style: ["itemNumber", "right"],
                          },
                        ],
                        [
                          {
                            text: "Withholding Tax",
                            style: "itemName",
                          },
                          {
                            text: this.numberComma(this.tax.toFixed(2)),
                            style: ["itemNumber", "right"],
                          },
                        ],
                        this.difference === "ค่าธรรมเนียมธนาคาร"
                          ? [
                              {
                                text: "Bank Fee",
                                style: "itemName",
                              },
                              {
                                text: this.numberComma(
                                  this.diffValue.toFixed(2)
                                ),
                                style: ["itemNumber", "right"],
                              },
                            ]
                          : [
                              {
                                text: "Deficit",
                                style: "itemName",
                              },
                              {
                                text: this.numberComma(
                                  this.diffValue.toFixed(2)
                                ),
                                style: ["itemNumber", "right"],
                              },
                            ],
                        [
                          {
                            text: "Balance",
                            style: "itemName",
                          },
                          {
                            text: this.numberComma(this.net.toFixed(2)),
                            style: ["itemNumber", "right"],
                          },
                        ],
                        [
                          {
                            text: "Net Receipt",
                            style: "itemName",
                            color: "#00A86C",
                            fontSize: 16,
                            fillColor: "#ebebeb",
                          },
                          {
                            text: this.numberComma(this.net.toFixed(2)),
                            style: ["itemNumber", "right"],
                            fontSize: 15,
                            fillColor: "#ebebeb",
                          },
                        ],
                        // END Items
                      ],
                    }, // table
                    //  layout: 'lightHorizontalLines'
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 4 || i === node.table.body.length
                          ? "black"
                          : "white";
                      },
                      vLineColor: "white",
                    },
                    unbreakable: true,
                  },
                  {
                    columns: [
                      {
                        text: "",
                      },
                      {
                        stack: [
                          {
                            text: this.authorize ? this.authorize : "",
                            style: "signature",
                          },
                          {
                            text: "_________________________________________",
                            style: this.authorize ? "" : "signaturePlaceholder",
                          },
                          {
                            text: "ผู้อนุมัติ / Authorized Signature",
                            style: "signatureName",
                          },
                        ],
                        width: 180,
                      },
                    ],
                  },
                ],
                unbreakable: true,
              },
              // {
              //   table: {
              //     // headers are automatically repeated if the table spans over multiple pages
              //     // you can declare how many rows should be treated as headers
              //     dontBreakRows: true,
              //     widths: [90, 90],
              //     body: [
              //       // Table Header
              //       [
              //         {
              //           text: "จำนวนเงินรวม (บาท)",
              //           style: "itemName",
              //         },
              //         {
              //           text: this.numberComma(this.price.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //         },
              //       ],
              //       [
              //         {
              //           text: "ภาษีหัก ณ ที่จ่าย (บาท)",
              //           style: "itemName",
              //         },
              //         {
              //           text: this.numberComma(this.tax.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //         },
              //       ],
              //       [
              //         {
              //           text: "ยอดสุทธิ (บาท)",
              //           style: "itemName",
              //         },
              //         {
              //           text: this.numberComma(this.net.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //         },
              //       ],
              //       [
              //         {
              //           text: "ชำระมาแล้ว (บาท)",
              //           style: "itemName",
              //           fillColor: "#ebebeb",
              //         },
              //         {
              //           text: this.numberComma(this.net.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //           fillColor: "#ebebeb",
              //         },
              //       ],
              //       // END Items
              //     ],
              //   }, // table
              //   //  layout: 'lightHorizontalLines'
              //   layout: {
              //     hLineColor: function(i, node) {
              //       return i === 3 || i === node.table.body.length
              //         ? "black"
              //         : "white";
              //     },
              //     vLineColor: "white",
              //   },
              //   unbreakable: true,
              // },
            ],
            unbreakable: true,
          },
          // Signature
          // {
          //   columns: [
          //     {
          //       text: "",
          //     },
          //     {
          //       stack: [
          //         {
          //           text: this.authorize ? this.authorize : "",
          //           style: "signature",
          //         },
          //         {
          //           text: "___________________________",
          //           style: this.authorize ? "" : "signaturePlaceholder",
          //         },
          //         {
          //           text: "ผู้อนุมัติ / Authorized Signature",
          //           style: "signatureName",
          //         },
          //       ],
          //       width: 180,
          //     },
          //   ],
          // },
        ],
        styles: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "left",
          },
          documentHeaderCenter: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "center",
          },
          documentHeaderRight: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "right",
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "left",
          },
          documentFooterCenter: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "center",
          },
          documentFooterRight: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "right",
          },
          // Invoice Title
          invoiceTitle: {
            fontSize: 16,
            bold: true,
            alignment: "left",
            margin: [0, 0, 0, 4],
          },
          invoiceText: {
            fontSize: 16,
            bold: true,
            alignment: "center",
            margin: [0, 10, 0, 0],
          },
          invoiceNumber: {
            fontSize: 14,
            margin: [0, 3, 0, 3],
          },
          invoiceStatus: {
            fontSize: 12,
            alignment: "center",
          },
          // Invoice Details
          invoiceSubTitle: {
            fontSize: 12,
            alignment: "left",
            margin: [0, 0, 0, 4],
          },
          invoiceDetail: {
            fontSize: 12,
            alignment: "right",
            margin: [0, 0, 0, 4],
          },
          // Billing Headers
          contact: {
            fontSize: 12,
            alignment: "left",
            lineHeight: 1.5,
            margin: [0, 5, 0, 0],
          },
          memberTitle: {
            fontSize: 13,
            alignment: "left",
            decoration: "underline",
            margin: [0, 0, 0, 5],
          },
          memberDetail: {
            fontSize: 12,
            alignment: "left",
            lineHeight: 1.5,
          },
          // Billing Details
          invoiceBillingDetails: {
            alignment: "left",
          },
          // Items Header
          itemsHeader: {
            fontSize: 12,
            margin: [0, 5, 0, 5],
            bold: true,
          },
          // Item Title
          itemTitle: {
            bold: true,
          },
          itemNumber: {
            margin: [0, 5, 0, 5],
            fontSize: 12,
          },
          itemName: {
            margin: [0, 5, 0, 5],
            fontSize: 12,
          },
          itemTax: {
            margin: [0, 5, 0, 5],
            alignment: "center",
            fontSize: 12,
          },
          itemTotal: {
            margin: [0, 5, 0, 5],
            alignment: "right",
            fontSize: 12,
          },
          signature: {
            fontSize: 12,
            alignment: "center",
            margin: [0, 30, 0, 0],
          },
          signaturePlaceholder: {
            margin: [0, 30, 0, 0],
          },
          signatureName: {
            fontSize: 12,
            alignment: "center",
          },
          center: {
            alignment: "center",
          },
          right: {
            alignment: "right",
          },
        },
        defaultStyle: {
          columnGap: 0,
          font: "THSarabun",
        },
      };
      if (this.$route.path.includes("email")) {
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        // pdfMake.createPdf(docDefinition).open({}, window.open("", "_blank"));
        pdfDocGenerator.getBlob(async (blob) => {
          const file = new File([blob], `${this.receiptID}.pdf`);
          this.receiptFile = file;
          const formData = new FormData();
          formData.append("file", file);
          formData.append("folder_id", this.folderId);
          console.log(blob);
          const fileRes = await axios.post(`${fileUrl}/file/create`, formData);
          console.log(fileRes.data);
          const fileId = fileRes.data.data.uploadFileAtLevel.file_id;
          const permissionRes = await axios.post(
            `${baseUrl}/file/file/create`,
            {
              file_id: fileId,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(permissionRes);
        });
      } else {
        pdfMake.createPdf(docDefinition).download(`${this.receiptID}.pdf`);
        // pdfMake.createPdf(docDefinition).open({}, window.open("", "_blank"));
      }
    },
  },
};
</script>

<style scoped>

.download-form {
  font-family: THSarabun, Helvetica, Arial, sans-serif !important;
  font-size: 17px;
  height: 100px;
  width: 100%;
}
p {
  color: blueviolet;
}
</style>
